import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          data-testid="back-to-top-btn"
          className="fixed bottom-8 right-6 md:right-10 z-40 bg-white border border-ink-100 shadow-card w-12 h-12 rounded-full flex items-center justify-center hover:border-brand-400 hover:shadow-brand"
          aria-label="Back to top"
        >
          <ArrowUp className="w-4 h-4 text-ink-700" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
